<template>
  <div class="joinus-container">
    <div class="banner">
      <img v-lazy="banner" alt />
    </div>
    <div class="content">
      <div class="vacancy">
        <div class="tit">
          <h2>招聘职位</h2>
          <span>RECRUITMENT POSITION</span>
        </div>
        <div class="vacancy-wrap">
          <div class="vacancy-box">
            <div class="vacancy-header">
              <span>职位名称</span>
              <span>职位类别</span>
              <span>工作地点</span>
              <span>发布时间</span>
            </div>
            <ul class="vacancy-list">
              <li v-for="(item,index) in list" :key="index">
                <span @click="jumpDetail(item.id)">{{item.employ_title}}</span>
                <span>{{item.category_name}}</span>
                <span>{{item.address}}</span>
                <span>{{item.add_time}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      banner: require("../assets/image/joinus_ad.jpg"),
      list: [],
    };
  },
  methods: {
    jumpDetail: function(employId) {
      this.$router.push({ path: "/EmployDetail", query: { employId: employId } });
    }
  },
  mounted: function() {
    //获取招聘列表
    this.axios.get("/niuniu_api.php?action=employ").then(response => {
      let res = response.data;
      if (res.errcode == 0) {
        this.list = res.data;
      } else {
        console.log(res.errmsg);
      }
    });
  }
};
</script>

<style scoped>
.joinus-container {
  background-color: #f4f4f6;

}
.banner img {
  width: 100%;
}

.vacancy {
  background-color: #fff;
  padding-top: 30px;
}

.vacancy-wrap {
  padding: 20px 100px 60px;
}

.vacancy-box {
  border: 1px solid #e7e7e7;
}

.vacancy-header {
  overflow: hidden;
  background-color: #f5f5f5;
}

.vacancy-header span,
.vacancy-list li span {
  display: block;
  float: left;
  width: 25%;
  font-size: 18px;
  height: 58px;
  line-height: 58px;
  text-align: center;
}

.vacancy-list li {
  overflow: hidden;
}

.vacancy-list li span:first-child {
  cursor: pointer;
  color: #000;
}

.vacancy-list li span:first-child:hover {
  color: #e23251;
}

.vacancy-list li span {
  font-size: 14px;
  color: #999;
  height: 48px;
  line-height: 48px;
}

.welfare-treatment {
  padding-top: 60px;
}

.joinus-container .tit {
  text-align: center;
  line-height: 1.3;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}

.joinus-container .tit h2 {
  font-size: 30px;
  font-weight: bold;
}
.joinus-container .tit span {
  font-size: 16px;
  color: #a6a6a6;
}
.welfare-show {
  padding: 40px 90px 80px;
}

.welfare-show img {
  width: 100%;
}

.company-photo {
  margin: 30px auto 0;
  position: relative;
}

.company-photo img {
  width: 100%;
  display: block;
}

.company-show {
  background: url(../assets/image/photo_bg.png) no-repeat 94px 87px;
  background-size: auto 570px;
  padding-bottom: 60px;
}

.company-photo .swiper-button-prev,
.company-photo .swiper-button-next {
  background: url(../assets/image/arrow_left.png) no-repeat;
  width: 50px;
  height: 50px;
}

.company-photo .swiper-button-next {
  background: url(../assets/image/arrow_right.png) no-repeat;
}

.vacancy-area {
  overflow: hidden;
  padding: 20px 10px;
  min-height: 600px;
}
.vacacy-tab {
  width: 17.8%;
  float: left;
  border: 1px solid #ebebeb;
  border-bottom: none;
  border-radius: 4px;
  overflow: hidden;
}

.vacacy-tab li {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  border-bottom: 1px solid #ebebeb;
  cursor: pointer;
}

.vacacy-tab li span {
  opacity: 0;
  transition: all 0.3s;
  display: inline-block;
}
.vacacy-tab li.active {
  color: #e23251;
}
.vacacy-tab li.active span {
  transform: translateX(20px);
  opacity: 1;
}

.vacancy-desc {
  width: 79%;
  float: right;
}

.vacancy-desc .item {
  border: 1px solid #ebebeb;
  padding: 20px;
  border-radius: 4px;
  font-size: 16px;
  line-height: 30px;
  margin-bottom: 20px;
}

.vacancy-desc .item:last-child {
  margin-bottom: 0;
}

.vacancy-desc .item h3 {
  margin-bottom: 25px;
  font-size: 16px;
  font-weight: bold;
}
.vacancy-btn {
  text-align: right;
  margin-top: 20px;
}
.vacancy-btn span {
  background: url(../assets/image/vacancy_bt.png) no-repeat;
  width: 189px;
  height: 61px;
  text-align: center;
  line-height: 62px;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
}
.vacancy-btn span:hover {
  background: url(../assets/image/vacancy_bt_hover.png) no-repeat;
}

.vacancy-popup-wrap .mask {
  content: "";
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
  transition: background-color 1s 1s;
}

.vacancy-popup-body {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 412px;
  margin: -120px 0 0 -206px;
  z-index: 11;
  border-radius: 4px;
  overflow: hidden;
}

.vacancy-popup-body h2 {
  line-height: 48px;
  border-bottom: 1px solid #ddd;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  background-color: #fff;
}

.vacancy-popup-content {
  padding: 20px 50px;
  background-color: #fff;
}
.vacancy-popup-content p {
  text-align: center;
  color: #35060a;
  font-size: 18px;
  line-height: 36px;
}

.vacancy-popup-content .ok-btn {
  width: 162px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  background-color: #e23251;
  border-radius: 4px;
  color: #fff;
  font-size: 18px;
  margin: 30px auto 0;
  cursor: pointer;
  transition: all 0.3s;
}

.welfare-show {
  padding: 20px 0 20px 0;
}

.vacancy-popup-content .ok-btn:hover {
  background-color: #f5254a;
}

.bounceIn-enter-active {
  animation: bounce-in 0.3s;
}
.bounceIn-leave-active {
  animation: bounce-in 0.3s reverse;
}

@keyframes bounce-in {
  0% {
    opacity: 0;
    transform: scale3d(0, 0, 1);
  }

  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}

.fade-right-enter-active {
  animation: fadeRight 1s;
}
@keyframes fadeRight {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 767px) {
  .welfare-treatment {
    padding-top: 20px;
  }
  .welfare-show {
    padding: 20px 0;
  }
  .company-photo {
    width: auto;
    padding: 0 20px;
    margin: 30px auto 0;
  }
  .company-show {
    padding-bottom: 30px;
  }

  .vacacy-tab li {
    text-align: center;
  }

  .vacacy-tab li span {
    display: none;
  }

  .vacancy-area {
    padding: 20px 10px;
    display: -webkit-box;
  }

  .vacacy-tab {
    float: none;
    width: 80px;
    margin-right: 10px;
    display: inline-block;
  }

  .vacancy-btn span,
  .vacancy-btn span:hover {
    width: 95px;
    height: 31px;
    line-height: 32px;
    font-size: 12px;
    background-size: 95px 31px;
  }

  .vacancy-popup-body {
    width: 90%;
    margin: -120px 0 0 -45%;
  }

  .vacancy-desc {
    float: none;
    width: auto;
    flex: 1;
  }
}
@media (max-width: 768px) {
  .vacancy {
    padding-top: 10px;
  }
  .vacacy-tab li {
    text-align: center;
  }

  .vacacy-tab li span {
    display: none;
  }

  .vacancy-popup-body {
    width: 90%;
    margin: -120px 0 0 -45%;
  }

  .content {
    padding: 0;
  }

  .vacancy-header span {
    font-size: 14px;
  }
  .vacancy-list li span {
    font-size: 12px;
  }
  .vacancy-wrap {
    padding: 10px 10px 30px;
  }
}


</style>